var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.isAuthorized)?_c('NavBar'):_vm._e(),(_vm.isAuthorized)?_c('div',{staticClass:"main-container"},[_c('v-main',[_c('router-view')],1)],1):_c('v-main',[_c('router-view')],1),(_vm.isAuthorized)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }